import { assertNever } from '@framework/engine/utils/assertNever.ts';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { SubjectDataType } from './ISubjectDataDirective.ts';

interface ISubjectDataTypeTagProps {
  type?: SubjectDataType | null;
  mini?: boolean;
}

/**
 * Tag del tipo di soggetto
 */
export function SubjectDataTypeTag(props: ISubjectDataTypeTagProps) {
  const { type, mini } = props;
  const dossierTagProps = useSubjectDataTag(type);

  if (!dossierTagProps) return null;

  return <StyledTag mini={mini} {...dossierTagProps} />;
}

/**
 * Ritorna le impostazioni per il tag
 *
 */
function useSubjectDataTag(type?: SubjectDataType | null) {
  const theme = useTheme();

  const tag = useMemo(() => {
    if (!type) return;

    switch (type) {
      case SubjectDataType.Applicant:
        return {
          color: theme?.colorPrimary ?? '#1890ff',
          children: 'TITOLARE',
        };
      case SubjectDataType.Successor:
        return {
          color: theme?.colorSuccess ?? '#389e0d',
          children: 'SUBENTRANTE',
        };
      case SubjectDataType.Company:
        return {
          color: '#8b1eba',
          children: 'AZIENDA',
        };
      case SubjectDataType.Attorney:
        return {
          color: '#0fa8a5',
          children: 'PROCURATORE',
        };
    }
    assertNever(type);
  }, [type, theme]);

  return tag;
}
